import axios from 'axios';
import { postFiles } from '../util/axios';

export const apiAllMemberships = ({ pageSize, page, sorted, filtered }) => {
  const sort = sorted.map((column) => `${column.id},${column.desc ? 'desc' : 'asc'}`);
  const filter = filtered.map((column) => `${column.id},${column.value}`);
  return axios.get(`/api/admin/memberships`, { params: { limit: pageSize, page, sort, filter }, skipLoader: true });
};
export const apiRequestMembership = ({ token, ...payload }) =>
  postFiles('/api/membership', { ...payload, stripeToken: token });
export const apiGetMembership = (id) => axios.get(`/api/admin/membership/${id}`);
export const apiReviewMembership = (id, payload) => axios.post(`/api/admin/membership/${id}`, payload);
export const apiDeleteMembershipRequest = (id) => axios.delete(`/api/admin/membership/${id}`);
export const apiDeleteUserMembership = (id) => axios.delete(`/api/admin/user-membership/${id}`);

export const apiAdminCreateMembership = (id, membershipId) =>
  axios.post(`/api/admin/user/${id}/membership/${membershipId}`);
